module.exports = __webpack_public_path__ + "img/revolutionary.2d56d825.png";